import { SpriteConstant } from './../../../constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Istage } from '../../../../framework/Istage';
import { MapKeyConstant } from '../../../class/MapKeyConstant';
import { CommonLayout } from '../../../layout/common.layout.const';
import { TutorialDesktopPosition } from '../../../constant/tutorial.desktop.position';
import { TranslateService } from '@ngx-translate/core';
import { FontTranslationProp } from '../../../constant/fonttranslationprop';
import { UtilService } from '../../../util/UtilService';
import { FirebaseConstant } from '../../../constant/firebase.constant';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { Settings } from './../../../models/settings/settings';
import { PageConstant } from 'src/app/constant/page.constant';

@Component({
    selector: 'app-fc21tutorials',
    templateUrl: './fc21tutorials.component.html',
    styleUrls: ['./fc21tutorials.component.scss'],
    standalone: false
})
export class FC21TutorialsComponent implements OnInit {
  @HostListener('document:keydown', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (event.key.toLowerCase() == 'escape') {
      this.buttonClick('close');
    }
    if (
      event.key.toLowerCase() == 'arrowleft' ||
      event.key.toLowerCase() == 'uikeyinputleftarrow'
    ) {
      this.buttonClick('left');
    }
    if (
      event.key.toLowerCase() == 'arrowright' ||
      event.key.toLowerCase() == 'uikeyinputrightarrow'
    ) {
      this.buttonClick('right');
    }
  }

  @Input() language: any = 'en';
  @Input() display: number = 1;
  @Input() overlayScreenDisplay: number = -1;
  @Input() layoutdata: Istage = {
    stageWidth: 1280,
    stageHeight: 720,
    stageLeft: 0,
    stageTop: 0,
    stageZ: 1000,
    position: 'absolute',
    overflow: 'visible',
    name: 'updatescale',
  };
  @Input() scaleR: any = {
    scale: 1,
    scaleX: 1,
    scaleY: 1,
    offsetLeft: 0,
    offsetTop: 0,
  };
  @Input() data;
  @Input() canPlayGame;
  @Input() tutorialPageCount: number = 0;
  @Input() helpContentStage: Istage = {
    stageWidth: 1280,
    stageHeight: 720,
    stageLeft: 0,
    stageTop: 0,
    stageZ: 1000,
    position: 'absolute',
    overflow: 'visible',
  };
  @Input() helpCloseStage: Istage;
  @Input() navKey: string;
  @Input() currentQuickTipsID = -1;
  @Input() rouletteScore;
  @Input() isSplit5to10 = true;
  @Input() currentSplitCardObj;
  @Input() superNaturalCardObj;
  @Input() doubleNaturalCardObj;
  @Input() naturalZeroCardObj;
  @Input() isDisplayAllButtons: boolean = true;
  @Output() tutorialsChange: EventEmitter<object> = new EventEmitter<object>();
  @Output() tutorialPageCountemit: EventEmitter<any> = new EventEmitter<any>();
  paysContentFont;
  percentageContentFont;
  paysContentFontSize;
  percentageContentFontSize;
  fontTranslationConst;
  scalVal = 1;
  touchStartVal = 0;
  touchMoveVal = 0;
  touchX = 0;
  touchY = 0;
  scaleWidth = 0;
  scaleHeight = 0;
  minusXValue = 0;
  minusYValue = 0;
  scalValOnEnd = 0;
  scaleValOnTouchEnd = 0;
  splitCard1 = 'green_5';
  splitCard2 = 'blue_5';
  superNaturalCard1 = 'green_11';
  superNaturalCard2 = 'orange_11';
  doubleNaturalCard1 = 'white_7';
  doubleNaturalCard2 = 'white_7';
  naturalZeroCard1 = 'white_5';
  naturalZeroCard2 = 'blue_5';
  cardsOptions;
  public settingsContentStage: Istage;
  /*"LANG00783":"Pays 1 to 1",
   "LANG00784":"Pays 2 to 1",
   "LANG00785":"Pays 3 to 1",
   "LANG00786":"Pays 3 to 2",
   "LANG00787":"Pays 4 to 1",
   "LANG00788":"Pays 5 to 1",
   "LANG00789":"Pays 6 to 5",
   "LANG00790":"Pays 7 to 2",
   "LANG00791":"Pays 7 to 5",
   "LANG00792":"Pays 8 to 5",
   "LANG00793":"Pays 9 to 5",*/
  public tutorialCount: number = 0;
  public TotalTutorialCount: number = 20;

  public tutorialClickArrayFromParent = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21,
  ];
  public tutorialClickArray = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
  ];
  public tutorialClickArrayHebrew = [
    10, 11, 12, 13, 14, 15, 16, 17, 18, 1, 2, 3, 4, 5, 6, 7, 8, 9,
  ];
  public imgBackGround: string = 'Tutorial_Background@2x.webp';
  public pays_blank_tutorial: object;

  helpContentStageNoResizeChild: Istage = {
    stageWidth: 815,
    stageHeight: 600,
    stageLeft: 230,
    stageTop: 60,
    stageZ: 1005,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };
  helpContentStageNoResizeChild1: Istage = {
    stageWidth: 815,
    stageHeight: 600,
    stageLeft: 230,
    stageTop: 60,
    stageZ: 1000,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };
  helpTutorialContentStageNoResizeChild: Istage = {
    stageWidth: 815,
    stageHeight: 461,
    stageLeft: 230,
    stageTop: 133,
    stageZ: 1005,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };
  quickKeysContentStageNoResizeChild: Istage = {
    stageWidth: 661,
    stageHeight: 600,
    stageLeft: 310,
    stageTop: 60,
    stageZ: 1005,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };

  splittopcardsposition: any = {};
  splitcardsposition: any = {};
  rouletteposition: any = {};
  quickkeysheaderposition: any = {};
  handcardtutorialposition: any = {};

  public tutorialContent: any = {
    TN_image_0: 'Tutorial_00_Index@2x.webp',
    TN_image_1: 'Tutorial_01_Introduction@2x.webp',
    TN_image_2: 'Tutorial_02_Scores@2x.webp',
    TN_image_3: 'Tutorial_03_GameAction@2x.webp',
    TN_image_4: 'Tutorial_04_GameRules@2x.webp',
    TN_image_5: 'Tutorial_05_Soft17@2x.webp',
    TN_image_6: 'Tutorial_06_StartAGame@2x.webp',
    TN_image_7: 'Tutorial_07_NaturalHands@2x.webp',
    TN_image_8: 'Tutorial_08_SNWins@2x.webp',
    TN_image_9: 'Tutorial_09_N21Wins@2x.webp',
    TN_image_10: 'Tutorial_10_DNWins@2x.webp',
    TN_image_11: 'Tutorial_11_NZWins@2x.webp',
    TN_image_12: 'Tutorial_12_BustOver22@2x.webp',
    TN_image_13: 'Tutorial_13_Splits_5-9@2x.webp',
    TN_image_14: 'Tutorial_14_ImpossibleSplits@2x.webp',
    TN_image_15: 'Tutorial_15_DoubleDown@2x.webp',
    TN_image_16: 'Tutorial_16_ColorInsurance@2x.webp',
    TN_image_17: 'Tutorial_17_WhiteInsurance@2x.webp',
    TN_image_18: 'Tutorial_18_Russian_Roulette@2x.webp',
    TN_image_19: 'Tutorial_19_PremiumPayouts@2x.webp',
    TN_image_20: 'Tutorial_AboutUs@2x.webp',
    TN_image_21: 'Tutorial_QuickKeys@2x.webp',
    TN_image_22: 'Tutorial_General@2x.webp',
    TN_image_23: 'Tutorial_General_No_RTP@2x.webp',
  };

  public percentageContent: Object = {
    100: 'LANG00885',
    120: 'LANG00891',
    140: 'LANG00893',
    150: 'LANG00888',
    200: 'LANG00886',
    250: 'LANG00414',
    300: 'LANG00887',
    350: 'LANG00892',
    400: 'LANG00889',
    450: 'LANG00895',
    500: 'LANG00890',
  };

  mapKeyConstant: any = MapKeyConstant.FC21KEYS;
  _subscriptionScale;

  version = '';
  constructor(
    public translate: TranslateService,
    public _utilService: UtilService,
    public firebaseAnalyticsServices: FirebaseAnalyticsService
  ) {
    //console.log("data.currentLanguage",this.language);
    this._subscriptionScale = _utilService.scaleChange.subscribe((value) => {
      // console.log('_subscriptionScale');
      // console.log(value);
      this.scaleR = value;
    });
    this.settingsContentStage = CommonLayout.HELP_CONTENT;
    this.splittopcardsposition = TutorialDesktopPosition.SPLITTOPCARDSPOSITION;
    this.splitcardsposition = TutorialDesktopPosition.SPLITCARDSPOSITION;
    this.rouletteposition = TutorialDesktopPosition.ROULETTEPOSITION;
    this.quickkeysheaderposition =
      TutorialDesktopPosition.QUICKKEYSHEADERPOSITION;
    this.settingsContentStage.stageTop = 135;
    this.settingsContentStage.stageHeight = 435;
    this.settingsContentStage.stageZ = 994;
    this.scaleWidth = 815;
    this.scaleHeight = 600;
    this.minusXValue = 30;
    this.minusYValue = 15;
    this.cardsOptions = SpriteConstant.HISTORY_CARDS;
    this.version = PageConstant.VERSION;
  }

  ngOnChanges(data) {
    //console.log('changing -------desktop', data);
    if (data.isSplit5to10) {
      this.isSplit5to10 = data.isSplit5to10.currentValue;
      if (this.isSplit5to10) {
        this.tutorialContent.TN_image_13 = 'Tutorial_13_Splits_5-9@2x.webp';
      } else {
        this.tutorialContent.TN_image_13 = 'Tutorial_13_Splits_1-10@2x.webp';
      }
    }
    /*if (data.currentSplitCardObj) {
      this.currentSplitCardObj = data.currentSplitCardObj.currentValue;
      this.splitCard1 = this.currentSplitCardObj.splitCard1 ? this.currentSplitCardObj.splitCard1 : 'green_5';
      this.splitCard2 = this.currentSplitCardObj.splitCard2 ? this.currentSplitCardObj.splitCard2 : 'blue_5';
    }
    if (data.superNaturalCardObj) {
      this.superNaturalCardObj = data.superNaturalCardObj.currentValue;
      this.superNaturalCard1 = this.superNaturalCardObj.superNaturalCard1 ? this.superNaturalCardObj.superNaturalCard1 : 'green_11';
      this.superNaturalCard2 = this.superNaturalCardObj.superNaturalCard2 ? this.superNaturalCardObj.superNaturalCard2 : 'orange_11';
    }
    if (data.doubleNaturalCardObj) {
      this.doubleNaturalCardObj = data.doubleNaturalCardObj.currentValue;
      this.doubleNaturalCard1 = this.doubleNaturalCardObj.doubleNaturalCard1 ? this.doubleNaturalCardObj.doubleNaturalCard1 : 'white_7';
      this.doubleNaturalCard2 = this.doubleNaturalCardObj.doubleNaturalCard2 ? this.doubleNaturalCardObj.doubleNaturalCard2 : 'white_7';
    }
    if (data.naturalZeroCardObj) {
      this.naturalZeroCardObj = data.naturalZeroCardObj.currentValue;
      this.naturalZeroCard1 = this.naturalZeroCardObj.naturalZeroCard1 ? this.naturalZeroCardObj.naturalZeroCard1 : 'white_5';
      this.naturalZeroCard2 = this.naturalZeroCardObj.naturalZeroCard2 ? this.naturalZeroCardObj.naturalZeroCard2 : 'blue_5';
    }*/
    if (data.overlayScreenDisplay) {
      let display: number = data.overlayScreenDisplay.currentValue;
      if (display == 0) {
        this.tutorialPageCountemit.emit(0);
        this.tutorialPageCount = 0;
        this.tutorialCount = 0;
        this.buttonClick('close');
      }
    }

    if (data.tutorialPageCount) {
      this.tutorialPageCount = data.tutorialPageCount.currentValue;
      this.tutorialClickFromParent(this.tutorialPageCount);
      this.updateTutorialContent();
    }
    //console.log("data.currentLanguage",this.language);
    this.pays_blank_tutorial = {
      TN_pays_blank_position_0: [],
      TN_pays_blank_position_1: [],
      TN_pays_blank_position_2: [],
      TN_pays_blank_position_3: [],
      TN_pays_blank_position_4: [],
      TN_pays_blank_position_5: [],
      TN_pays_blank_position_6: [],
      TN_pays_blank_position_7: [],
      TN_pays_blank_position_8: [
        {
          paysContent: this.percentageContent[this.data.supernaturalpercentage], //'LANG00886',//(this.language == 'ar' || this.language == 'he' ? 'LANG00783' : 'LANG00784'),
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.supernaturalpercentage
              : this.data.supernaturalpercentage + '%',
          width: 128,
          height: 46,
          left: 349,
          top: 436,
        },
      ],
      TN_pays_blank_position_9: [
        {
          paysContent:
            this.percentageContent[this.data.naturaltwentyonepercentage], //'LANG00888',//(this.language == 'ar' || this.language == 'he' ? 'LANG00783' : 'LANG00786'),
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturaltwentyonepercentage
              : this.data.naturaltwentyonepercentage + '%',
          width: 128,
          height: 46,
          left: 349,
          top: 436,
        },
      ],
      TN_pays_blank_position_10: [
        {
          paysContent:
            this.percentageContent[this.data.doublenaturalpercentage], //'LANG00885',//(this.language == 'ar' || this.language == 'he' ? 'LANG00786' : 'LANG00783'),
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.doublenaturalpercentage
              : this.data.doublenaturalpercentage + '%',
          width: 128,
          height: 46,
          left: 349,
          top: 436,
        },
      ],
      TN_pays_blank_position_11: [
        {
          paysContent: this.percentageContent[this.data.naturalzeropercentage], //'LANG00885',//(this.language == 'ar' || this.language == 'he' ? 'LANG00784' : 'LANG00783'),
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturalzeropercentage
              : this.data.naturalzeropercentage + '%',
          width: 128,
          height: 46,
          left: 349,
          top: 436,
        },
      ],
      TN_pays_blank_position_12: [],
      TN_pays_blank_position_13: [],
      TN_pays_blank_position_14: [],
      TN_pays_blank_position_15: [],
      TN_pays_blank_position_16: [
        {
          paysContent:
            this.percentageContent[this.data.colorcardinsurancepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.colorcardinsurancepercentage
              : this.data.colorcardinsurancepercentage + '%',
          width: 128,
          height: 46,
          left: FontTranslationProp[this.language]
            .TN_pays_blank_position_16_Left,
          top: FontTranslationProp[this.language].TN_pays_blank_position_16_Top,
        },
      ],
      TN_pays_blank_position_17: [
        {
          paysContent:
            this.percentageContent[this.data.whitecardinsurancepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.whitecardinsurancepercentage
              : this.data.whitecardinsurancepercentage + '%',
          width: 128,
          height: 46,
          left: FontTranslationProp[this.language]
            .TN_pays_blank_position_17_Left,
          top: FontTranslationProp[this.language].TN_pays_blank_position_17_Top,
        },
      ],
      TN_pays_blank_position_18: [
        {
          // (language == 'he' || language == 'ar')? (0 * scaleR.scaleX) : ((language == 'ph')? (7 * scaleR.scaleX) : (5* scaleR.scaleX))
          paysContent:
            this.language == 'ar' || this.language == 'he'
              ? this.percentageContent[this.data.russianroulette20percentage]
              : this.percentageContent[this.data.russianroulette17percentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.russianroulette20percentage
              : this.data.russianroulette17percentage + '%',
          width: 128,
          height: 46,
          left: {
            ar: 102,
            hy: 90,
            bg: 93,
            kh: 90,
            'zh-Hans': 93,
            'zh-Hant': 93,
            cs: 94,
            da: 95,
            nl: 94,
            en: 97,
            ee: 90,
            ph: 87,
            fi: 94,
            fr: 96,
            ge: 90,
            de: 97,
            gr: 94,
            he: 94,
            'hi-IN': 94,
            hu: 90,
            id: 94,
            it: 80,
            ja: 94,
            ko: 94,
            lv: 88,
            lt: 90,
            my: 89,
            mt: 94,
            nb: 94,
            pl: 94,
            'pt-BR': 94,
            ro: 94,
            ru: 94,
            'sr-RS': 94,
            sk: 94,
            si: 92,
            es: 94,
            sv: 94,
            'ta-IN': 84,
            th: 94,
            tr: 86,
            ua: 94,
            vi: 84,
          },
          top: 475,
        },
        {
          paysContent:
            this.language == 'ar' || this.language == 'he'
              ? this.percentageContent[this.data.russianroulette19percentage]
              : this.percentageContent[this.data.russianroulette18percentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.russianroulette19percentage
              : this.data.russianroulette18percentage + '%',
          width: 128,
          height: 46,
          left: {
            ar: 267,
            hy: 257,
            bg: 264,
            kh: 265,
            'zh-Hans': 264,
            'zh-Hant': 264,
            cs: 266,
            da: 262,
            nl: 266,
            en: 266,
            ee: 257,
            ph: 255,
            fi: 267,
            fr: 266,
            ge: 257,
            de: 268,
            gr: 262,
            he: 266,
            'hi-IN': 266,
            hu: 258,
            id: 265,
            it: 257,
            ja: 269,
            ko: 266,
            lv: 256,
            lt: 259,
            my: 259,
            mt: 261,
            nb: 266,
            pl: 266,
            'pt-BR': 266,
            ro: 266,
            ru: 263,
            'sr-RS': 266,
            sk: 266,
            si: 260,
            es: 266,
            sv: 266,
            'ta-IN': 266,
            th: 258,
            tr: 256,
            ua: 263,
            vi: 261,
          },
          top: 475,
        },
        {
          paysContent:
            this.language == 'he' || this.language == 'ar'
              ? this.percentageContent[this.data.russianroulette18percentage]
              : this.percentageContent[this.data.russianroulette19percentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.russianroulette18percentage
              : this.data.russianroulette19percentage + '%',
          width: 128,
          height: 46,
          left: {
            ar: 425,
            hy: 429,
            bg: 431,
            kh: 426,
            'zh-Hans': 431,
            'zh-Hant': 430,
            cs: 432,
            da: 422,
            nl: 425,
            en: 434,
            ee: 423,
            ph: 423,
            fi: 439,
            fr: 434,
            ge: 430,
            de: 424,
            gr: 432,
            he: 432,
            'hi-IN': 432,
            hu: 427,
            id: 431,
            it: 432,
            ja: 432,
            ko: 432,
            lv: 424,
            lt: 422,
            my: 428,
            mt: 432,
            nb: 432,
            pl: 432,
            'pt-BR': 432,
            ro: 432,
            ru: 432,
            'sr-RS': 432,
            sk: 432,
            si: 427,
            es: 432,
            sv: 432,
            'ta-IN': 433,
            th: 418,
            tr: 426,
            ua: 432,
            vi: 432,
          },
          top: 475,
        },
        {
          paysContent:
            this.language == 'he' || this.language == 'ar'
              ? this.percentageContent[this.data.russianroulette17percentage]
              : this.percentageContent[this.data.russianroulette20percentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.russianroulette17percentage
              : this.data.russianroulette20percentage + '%',
          width: 128,
          height: 46,
          left: {
            ar: 593,
            hy: 601,
            bg: 598,
            kh: 594,
            'zh-Hans': 598,
            'zh-Hant': 599,
            cs: 602,
            da: 593,
            nl: 596,
            en: 604,
            ee: 590,
            ph: 606,
            fi: 602,
            fr: 602,
            ge: 602,
            de: 594,
            gr: 602,
            he: 597,
            'hi-IN': 602,
            hu: 595,
            id: 595,
            it: 602,
            ja: 604,
            ko: 602,
            lv: 596,
            lt: 595,
            my: 593,
            mt: 593,
            nb: 597,
            pl: 597,
            'pt-BR': 602,
            ro: 598,
            ru: 602,
            'sr-RS': 602,
            sk: 597,
            si: 597,
            es: 602,
            sv: 602,
            'ta-IN': 606,
            th: 591,
            tr: 598,
            ua: 597,
            vi: 609,
          },
          top: 475,
        },
      ],
      TN_pays_blank_position_19: [
        {
          paysContent: this.percentageContent[this.data.supernaturalpercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.supernaturalpercentage
              : this.data.supernaturalpercentage + '%',
          width: 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 593 : 84,
          top: 134,
        },
        {
          paysContent:
            this.percentageContent[this.data.naturaltwentyonepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturaltwentyonepercentage
              : this.data.naturaltwentyonepercentage + '%',
          width: 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 593 : 84,
          top: 191,
        },
        {
          paysContent:
            this.percentageContent[this.data.doublenaturalpercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.doublenaturalpercentage
              : this.data.doublenaturalpercentage + '%',
          width: 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 593 : 84,
          top: 248,
        },
        {
          paysContent: this.percentageContent[this.data.naturalzeropercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturalzeropercentage
              : this.data.naturalzeropercentage + '%',
          width: 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 593 : 84,
          top: 305,
        },
        {
          paysContent: 'LANG00885', //(this.language == 'ar' || this.language == 'he' ? 'LANG00783' : 'LANG00783'),
          percentageContent:
            this.language == 'he' || this.language == 'ar' ? '%100' : '100%',
          width: 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 593 : 84,
          top: 362,
        },
        {
          paysContent:
            this.percentageContent[this.data.colorcardinsurancepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.colorcardinsurancepercentage
              : this.data.colorcardinsurancepercentage + '%',
          width: 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 593 : 84,
          top: 419,
        },
        {
          paysContent:
            this.percentageContent[this.data.whitecardinsurancepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.whitecardinsurancepercentage
              : this.data.whitecardinsurancepercentage + '%',
          width: 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 593 : 84,
          top: 477,
        },
      ],
      TN_pays_blank_position_20: [],
      TN_pays_blank_position_21: [],
    };
    this.fontTranslationConst = FontTranslationProp[this.language];
  }

  updateTutorialContent() {
    this.language =
      this.translate.currentLang == 'desc' ||
      this.translate.currentLang == 'code'
        ? 'en'
        : this.translate.currentLang;
    this.percentageContentFont =
      FontTranslationProp[this.language].footerBetFontFamily;
    this.paysContentFont =
      FontTranslationProp[this.language].fc21paysTextFontFamily;
    this.paysContentFontSize =
      FontTranslationProp[this.language].paysContentFontSize;
    this.percentageContentFontSize =
      FontTranslationProp[this.language].percentageContentFontSize;
    this.fontTranslationConst = FontTranslationProp[this.language];
  }
  /*onLangClick(langcode) {
 //console.log("langcode",langcode);
   this.language = langcode;
   }*/

  ngOnInit() {
    this.language =
      this.translate.currentLang == 'desc' ||
      this.translate.currentLang == 'code'
        ? 'en'
        : this.translate.currentLang;
    this._utilService.loadfc21TutorialManifest();
  }

  ngAfterViewInit() {}

  tutorialClick(value) {
    if (this.language == 'he' || this.language == 'ar') {
      this.tutorialCount = this.tutorialClickArrayHebrew[value];
    } else {
      this.tutorialCount = this.tutorialClickArray[value];
    }
    if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
      this.firebaseAnalyticsServices.sendAction(
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventAction,
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].category,
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].Label,
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].catId,
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventId
      );
    }
  }

  tutorialClickFromParent(value) {
    this.tutorialCount = this.tutorialClickArrayFromParent[value];
  }

  buttonClick(value) {
    // console.log("buttonClick : "+value+' len : '+Object.keys(this.tutorialContent).length+" tutorialCount : "+this.tutorialCount);
    let contentObj: Object = this.tutorialContent;
    switch (value) {
      case 'left':
        if (this.isDisplayAllButtons) {
          this.tutorialCount > 0
            ? this.tutorialCount--
            : (this.tutorialCount = this.TotalTutorialCount);
          // console.log(this.tutorialCount);
          this.tutorialPageCountemit.emit({
            direction: 'left',
            tutorialCount: this.tutorialCount,
          });
        }
        if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]
              .eventAction,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].category,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].Label,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].catId,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventId
          );
        }
        break;
      case 'right':
        if (this.isDisplayAllButtons) {
          this.tutorialCount < this.TotalTutorialCount
            ? this.tutorialCount++
            : (this.tutorialCount = 0);
          // console.log(this.tutorialCount);
          this.tutorialPageCountemit.emit({
            direction: 'right',
            tutorialCount: this.tutorialCount,
          });
        }
        if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]
              .eventAction,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].category,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].Label,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].catId,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventId
          );
        }
        break;
      case 'home':
        this.display = 1;
        this.tutorialCount = 0;
        if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]
              .eventAction,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].category,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].Label,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].catId,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventId
          );
        }
        break;
      case 'close':
        if (this.isDisplayAllButtons) {
          // this.tutorialPageCountemit.emit(0);
          this.tutorialPageCount = 0;
          this.display = 0;
          if (this.canPlayGame) {
            // this.audioService.playVoiceSounds(['returntogame']);
          }
          // console.log("44-->audio-->returntogame");
          this.tutorialsChange.emit({ name: 'close' });
        }
        break;
      default:
        break;
    }
    this.updateTutorialContent();
    //console.log("this.soundvolume : "+this.soundvolume+"this.tutorialCount : "+this.tutorialCount+" name : "+contentObj['TN_image_'+this.tutorialCount]);
  }

  onTouchStart(event: TouchEvent): void {
    /*if (event.touches.length == 2) {
     // if(this.scalVal <= 1) {
     let diffX = Math.abs(event.touches[0].clientX - event.touches[1].clientX);
     let diffY = Math.abs(event.touches[0].clientY - event.touches[1].clientY);
     this.touchStartVal = Math.max(diffX, diffY);
     event.preventDefault();
     let medianX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
     let medianY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
     this.touchX = (Math.floor((medianX / this.scaleWidth) * 100) > 100) ? 100 : Math.floor((medianX / this.scaleWidth) * 100);
     this.touchY = (Math.floor((medianY / this.scaleHeight) * 100) > 100) ? 100 : Math.floor((medianY / this.scaleHeight) * 100);
     }*/
  }

  onTouchMove(event: TouchEvent): void {
    /*let len = event.touches.length;
     if (len == 2) {
     this.handle_pinch_zoom(event);
     event.preventDefault();
     } else {
     event.preventDefault();
     }*/
  }

  handle_pinch_zoom = (event) => {
    /*let diffX = Math.abs(event.touches[0].clientX - event.touches[1].clientX);
     let diffY = Math.abs(event.touches[0].clientY - event.touches[1].clientY);
     this.touchMoveVal = Math.max(diffX, diffY);
     let finalVal = this.touchMoveVal / this.touchStartVal;
     /!*this.val = this.scalVal;*!/
     if (this.scaleValOnTouchEnd <= 1) {
     this.scalVal = (finalVal <= 1) ? 1 : (finalVal >= 4) ? 4 : finalVal;
     } else {
     let value = (finalVal + this.scaleValOnTouchEnd) - 1;
     this.scalVal = ((value) <= 1) ? 1 : ((value) >= 4 ? 4 : (value));
     }
     let medianX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
     let medianY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
     this.touchX = (Math.floor(((medianX / this.scaleWidth) * 100) - this.minusXValue) > 100) ? 100 : Math.floor(((medianX / this.scaleWidth) * 100) - this.minusXValue);
     this.touchY = (Math.floor(((medianY / this.scaleHeight) * 100) - this.minusYValue) > 100) ? 100 : Math.floor(((medianY / this.scaleHeight) * 100) - this.minusYValue);*/
  };

  onTouchEnd = (scaleValue) => {
    this.scaleValOnTouchEnd = scaleValue;
  };

  getCardImage(cardValue) {
    // return SpriteController.getImageFromSprite(SpriteImage.simulatorcardsprite, SpriteImage.simulatorcards, SpriteImage.simulatorcardsjson, cardValue);
  }

  getImageFromQuickTipsSprite(imageName) {
    // return SpriteController.getImageFromSprite(SpriteImage.quicktipssprite, SpriteImage.quicktipsasset, SpriteImage.quicktipsspritejson, imageName);
  }
  onGeneralInfoClick = () => {
    if (Settings.appSettings.menu.fc21.tutorials.Generalgameinfo) {
      this.tutorialCount = 22;
    }
  };

  ngOnDestory() {
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this._subscriptionScale;
  }
}
